<template>
  <v-dialog v-model="dialog" width="850px" persistent>
    <template v-slot:activator="{ on }">
      <center>
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-btn
              v-on="on"
              slot="activator"
              color="secondary lighten-1"
              :elevation="hover ? 24 : 6"
              class="button mx-1 mt-1  font-weight-bold"
              rounded
            >
              Edit
            </v-btn>
          </template>
        </v-hover>
      </center>
    </template>

    <v-card elevation="8" style="border-radius: 13px;">
      <v-container>
        <v-layout row wrap>
          <v-col cols="12">
            <center>
              <h2
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline'
                ]"
                class="mb-4 font-weight-bold secondary--text"
              >
                Edit Item
              </h2>
            </center>
          </v-col>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-text>
              <v-text-field
                name="title"
                id="title"
                v-model="editedTitle"
                :label="item.itemName"
                required
              ></v-text-field>
              <v-textarea
                name="description"
                autogrow
                :placeholder="item.itemDescription"
                label="Description"
                id="description"
                multi-line
                v-model="editedDescription"
                required
              ></v-textarea>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
              <v-btn flat class="blue--text darken-1" @click="dialog = false"
                >Cancel</v-btn
              >
              <v-btn flat class="blue--text darken-1" @click="onSaveChanges"
                >Save</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import firebase from "firebase/compat/app";
export default {
  props: ['item'],
  components: {
    // Register: () => import('./Register.vue'),
    vueDropzone: vue2Dropzone
  },

  data() {
    return {
      enabled: false,
      checkbox: false,
      dialog: false,
      editedTitle: this.item.title,
      editedDescription: this.item.description,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { 'My-Awesome-Header': 'header value' }
      },
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Be more descriptive.',
        emailMatch: () => "The email and password you entered don't match"
      },
      custom: true,
      max: 500,
      e4: 1,
      dialog: false,
      category: [
        'Technology',
        'Transportation',
        'Household living',
        'DIY',
        'Exercise',
        'Music and Audio'
      ],
      area: [
        'Northern Suburbs',
        'Cape Town',
        'Atlantic Seaboard',
        'Stellenbosch',
        'Other'
      ],

      itemName: '',
      location: '',
      dailyFee: '',
      weeklyFee: '',
      monthlyFee: '',
      currentValue: '',
      terms: '',
      deposit: 'none',
      imageUrls: [],
      itemDescription: '',
      images: [],
      deliveryFee: 'NA',
      delivery: '',
      savedLocations: [],
      formData: {
        street: '',
        city: '',
        state: '',
        zip: ''
      },
      uploaded: 0
    }
  },
  computed: {
    item() {
      var a = this.$store.getters.loadedItems.filter((item) => {
        return item.id === this.$route.params.id
      })
      return a[0]
    },
    // item() {
    //   var a = this.$store.getters.loadedItems.filter((item) => {
    //     return item.id === this.$route.params.id
    //   })
    //   return a[0]
    // },
    // formIsValid() {
    //   return this.itemName.length > 7 && this.uploaded > 0
    // },
    // formIsValid1() {
    //   return this.category !== '' && this.itemDescription.length > 50
    // },
    // formIsValid2() {
    //   return (
    //     this.currentValue !== '' &&
    //     this.dailyFee !== '' &&
    //     this.weeklyFee !== '' &&
    //     this.monthlyFee !== ''
    //   )
    // },
    // formIsValid3() {
    //   return this.location !== '' && this.area !== '' && this.terms !== ''
    // },

    size() {
      const size = { xs: 'x-small', sm: 'small', lg: 'large', xl: 'large' }[
        this.$vuetify.breakpoint.name
      ]
      return size ? { [size]: true } : {}
    },

    progress() {
      return Math.min(100, this.itemDescription.length * 1.6)
    },
    color() {
      return ['red', 'orange', 'green'][Math.floor(this.progress / 40)]
    }
  },

  methods: {
    onSaveChanges() {
      if (
        this.editedTitle.trim() === '' ||
        this.editedDescription.trim() === ''
      ) {
        return
      }
      this.editDialog = false
      this.$store.dispatch('updateitemData', {
        id: this.item.id,
        title: this.editedTitle,
        description: this.editedDescription
      })
    }
  }
}
</script>

<style>
@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');

.button {
  padding: 1rem 4rem;
  border-radius: 100rem;
  background-color: rgb(231, 81, 43);
  color: white;
  width: 60%;
  font-weight: 700;
  transition: 0.5s;
}

.button:hover {
  width: 21rem;
}
</style>
